import { render } from "./PointView.vue?vue&type=template&id=c3b16636"
import script from "./PointView.vue?vue&type=script&lang=js"
export * from "./PointView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\StudentManageSystem\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__